export default __webpack_public_path__ + "static/media/project3.4464d426.png";